export default __webpack_public_path__ + "static/ath-fac-490d18bcc0d0914782923fc5ba2daec9.jpg";